export function P00080ConsignRXBas() {
  let r = [];

  for (let i = 0; i <= 850; i = i + 10) {
    r.push({
      ref: i * 100,
      label: i + ' mV',
    });
  }

  return r;
}

export function P00080ConsignRXHaut() {
  let r = [];

  for (let i = 500; i <= 1000; i = i + 10) {
    r.push({
      ref: Math.round(i * 100),
      label: i + ' mV',
    });
  }

  return r;
}

export function P00080ConsignRX() {
  let r = [];

  for (let i = 550; i <= 850; i = i + 10) {
    r.push({
      ref: Math.round(i * 100),
      label: i + ' mV',
    });
  }

  return r;
}

export function P00080ConsignPHBas() {
  let r = [];

  for (let i = 0; i <= 8.5; i = i + 0.1) {
    r.push({
      ref: Math.round(i * 100),
      label: i.toFixed(1).replace('.', ',') + ' pH',
    });
  }

  return r;
}

export function P00080ConsignPHHaut() {
  let r = [];

  for (let i = 6; i <= 14; i = i + 0.1) {
    r.push({
      ref: Math.round(i * 100),
      label: i.toFixed(1).replace('.', ',') + ' pH',
    });
  }

  return r;
}

export function P00080ConsignPH() {
  let r = [];

  for (let i = 6.5; i <= 8.0; i = i + 0.1) {
    r.push({
      ref: Math.round(i * 100),
      label: i.toFixed(1).replace('.', ',') + ' pH',
    });
  }

  return r;
}
